import SkillAssignmentReport from "./SkillAssignmentReport";
import LockUnlockReport from "./LockUnlockReport";
import ErrorReport from "./ErrorReport";
const ProcessLogContent = ({ event, eventSource, data }) => {
  const updatedData = data.filter(
    (item) => item.EVENT_SOURCE === event.EVENT_SOURCE
  );
  const renderContent = () => {
    switch (eventSource) {
      case "USER_LOCKED":
        return (
          <LockUnlockReport
            updatedData={updatedData}
            initialViewing={"Locked"}
          />
        );
      case "USER_UNLOCKED":
        return (
          <LockUnlockReport
            updatedData={updatedData}
            initialViewing={"Unlocked"}
          />
        );
      case "SKILL_ASSIGNED":
        return (
          <SkillAssignmentReport
            updatedData={updatedData}
            initialViewing={"Assigned"}
          />
        );
      case "SKILL_UNASSIGNED":
        return (
          <SkillAssignmentReport
            updatedData={updatedData}
            initialViewing={"Unassigned"}
          />
        );
      case "ERRORS_COUNT":
        return <ErrorReport updatedData={updatedData} />;
      default:
        return <div>default</div>;
    }
  };

  return <div>{renderContent()}</div>;
};

export default ProcessLogContent;
